import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ModalStateDto } from '../../dto/util/modal.dto';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private injector: Injector) {}

  private modalStateSubject = new BehaviorSubject<ModalStateDto>({
    isOpen: false,
  });
  modalState = this.modalStateSubject.asObservable();

  openModal(component: any, data: any) {
    const injector = Injector.create({
      providers: [{ provide: 'modalData', useValue: data }],
      parent: this.injector,
    });

    this.modalStateSubject.next({
      isOpen: true,
      contentComponent: component,
      contentInjector: injector,
    });
  }

  close() {
    this.modalStateSubject.next({ isOpen: false });
  }
}
